import Vue from 'vue';

const createComponent = (template, data) => {  // template is the raw html string
    const compiledTemplate = Vue.compile(template);
    return {
        data: () => {
            return data ? {...data} : {};
        },
        render: compiledTemplate.render,
        staticRenderFns: compiledTemplate.staticRenderFns,
    }
};

export default {
    name: 'TemplateRenderer',
    components: {},
    mixins: [],
    props: {
        content: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            
        }
    },
    computed: {
        
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        
    },
    render(createElement) {
        return createElement(
            'div',   // tag name - will wrap all fields in this at TOP LEVEL
            {},  // component data object 
            [
                createElement(
                    createComponent(this.content)
                )
            ]
        )
    },
}